import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, BookOpen, Home, MessageCircle, PlusCircle } from 'lucide-react';
import { Brain } from 'lucide-react';

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-gray-900 border-b border-gray-800 px-6 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <Link to="/dashboard" className="flex items-center gap-2">
          <span className="text-2xl font-black">
            <span className="text-green-400">Edu</span>
            <span className="text-white">Nex</span>
          </span>
        </Link>

        {/* Nav links */}
        <div className="flex items-center gap-6">
          <Link
            to="/dashboard"
            className="flex items-center gap-2 text-gray-400
                       hover:text-white transition-colors text-sm"
          >
            <Home size={16} />
            Dashboard
          </Link>

          <Link
            to="/courses"
            className="flex items-center gap-2 text-gray-400
                       hover:text-white transition-colors text-sm"
          >
            <BookOpen size={16} />
            Courses
          </Link>

          <Link
  to="/study-buddy"
  className="flex items-center gap-2 text-gray-400
             hover:text-white transition-colors text-sm"
>
  <MessageCircle size={16} />
  Study Buddy
</Link>

<Link
  to="/flashcards"
  className="flex items-center gap-2 text-gray-400
             hover:text-white transition-colors text-sm"
>
  <Brain size={16} />
  Review
</Link>

{(user?.role === 'TEACHER' ||
  user?.role === 'SUPER_ADMIN' ||
  user?.role === 'ADMIN') && (
  <Link
    to="/teacher"
    className="flex items-center gap-2 text-gray-400
               hover:text-white transition-colors text-sm"
  >
    <PlusCircle size={16} />
    Teach
  </Link>
)}
        </div>

        {/* User info + logout */}
        <div className="flex items-center gap-4">
          <div className="text-right">
            <div className="text-sm font-semibold text-white">
              {user?.fullName}
            </div>
            <div className="text-xs text-green-400">
              {user?.role}
            </div>
          </div>

          <button
            onClick={handleLogout}
            className="flex items-center gap-2 text-gray-400
                       hover:text-red-400 transition-colors text-sm"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}